import React from 'react';
import './zigzagcards.css';
import { useNavigate } from 'react-router-dom';

const ZigZagCards = ({ cards }:any) => {

  const navigate = useNavigate();

  return (
    <section className="zig-zag-card-section">
      <div className="zig-zag-card-section-header">
          {/* <h2>What We Do</h2>
          <p>Where vision meets execution. We transform landscapes, elevate experiences, and power progress across diverse industries.</p> */}
        </div>
      <div className="zig-zag-card-container">
        {cards.map((card:any, index:any) => (
          <div className={index%2 === 0 ? "zig-zag-card" : "zig-zag-card-reverse"} key={index} onClick={() => card.url && window.open(card.url, '_blank', 'noopener,noreferrer')} >
            <div className="zig-zag-card-content">
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </div>
            <div className="zig-zag-card-image">
              <img src={card.image} alt={card.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ZigZagCards;